import React, { FC } from "react";

export const secondsFormatConverter = (seconds: any) => {
  if (seconds) {
    seconds = Number(seconds);
    let d = Math.floor(seconds / (3600 * 24));
    let h = Math.floor((seconds % (3600 * 24)) / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    return (
      <>
        {d}
        <span>d </span>
        {h}
        <span>h </span> {m}
        <span>m </span>
      </>
    );
  } else {
    return (
      <>
        0
        <span>d </span>
        0
        <span>h </span> 0 
        <span>m </span>
      </>
    );
  }
};
